import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import React from 'react'

interface AdvertiserDomainCellProps {
  finish_domain: string
}

export const AdvertiserDomainCell = ({ finish_domain }: AdvertiserDomainCellProps) => {
  return (
    <BpAnchor href={`https://${finish_domain}`} target='_blank'>
      {finish_domain}
    </BpAnchor>
  )
}
